#import "../fragments/inbox-thread-fragment.graphql"

fragment InboxChannelFragment on InboxChannel {
    id
    status
    threads {
        latestThread {
            ...InboxThreadFragment
        }
        totalCount
        closedCount
    }
}
